import React from 'react'
import { observer } from 'mobx-react'
import { formatSalaryOptionLabel } from 'components/ContentBox/Global/Select/SelectCustomFunctions'
import modalStore from 'Stores/modalStore'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import SelectDateBirth from 'components/ContentBox/Global/SelectDateBirth/SelectDateBirth'
import { localisationMaster } from 'Localisation/Localisation'
import DateSpliter from 'components/ContentBox/Global/DateSpliter/DateSpliter'
import { timeConverter } from 'components/ContentBox/Online-schedule/components/functions'

const TeacherSalary = () => {
  const { modalValue, changeValues, check, getModalValues } = modalStore
  const arrayChangeHandler = (val) => {
    val.date_from && changeValues(val.date_from, 'date_from')
    val.date_until && changeValues(val.date_until, 'date_until')
  }
  return (
    <div className='super-modal__form-column'>
      <div>
        <SelectCustom
          placeholder={localisationMaster('text_1', 'groups/group', 'dors')}
          apiLink='ledger/salary_v2'
          apiConfParams={{
            limit: 999,
          }}
          getOptionLabel={(opt) => opt.name}
          formatOptionLabel={formatSalaryOptionLabel}
          valueID={modalValue.salary_hours_type}
          onChange={(o) => changeValues(o.id, 'salary_hours_type')}
          isSearchable
          error={check('salary_hours_type')}
        />
      </div>
      <DateSpliter
        yearsStart='currentPlus3'
        yearsEnd='currentPlus3'
        titles={[
          `${localisationMaster('start_date', 'groups/group', 'dors')}:`,
          `${localisationMaster('end_date', 'groups/group', 'dors')}:`,
        ]}
        keys={['date_from', 'date_until']}
        arrayChangeHandler={arrayChangeHandler}
        fix_data={{
          date_from: modalValue.date_from
            ? modalValue.date_from
            : timeConverter(new Date(), 'today'),
          date_until: modalValue.date_until && modalValue.date_until,
        }}
      />
      {/* <div className="super-modal__form-row2">

                    <div className="super-modal__form-field">
                    <span className="super-modal__form-label">Дата начала:</span>
                    <span className="super-modal__form-label">{localisationMaster('Today', 'online-schedule/time-slots')}</span>
                    <div>
                        <SelectDateBirth value={modalValue.date_from}
                                         onChange={val => changeValues(val, 'date_from')}
                                         years="currentPlus3"
                                         error={check('date_from')}
                        />
                    </div>
                </div>
                <div className="super-modal__form-field">
                    <span className="super-modal__form-label">Дата окончания:</span>
                    <span className="super-modal__form-label">{localisationMaster('text-10', 'filter')}</span>
                    <div>
                        <SelectDateBirth value={modalValue.date_until}
                                         onChange={val => changeValues(val, 'date_until')}
                                         years="currentPlus3"
                        />
                    </div>
                </div>
            </div> */}
    </div>
  )
}

export default observer(TeacherSalary)
